import { useState } from 'react';

import { OrderReason } from '../../../../../../../api-client';

export interface ICompleteDialogForm {
    note?: string;
    poNumber?: string;
    reason?: OrderReason;
}

const defaultValues = {
    note: '',
    poNumber: ''
}

export const useCompleteDialogForm = () => {
    const [formValues, setFormValues] = useState<ICompleteDialogForm>(defaultValues);

    const handleInitialize = (values: ICompleteDialogForm) => setFormValues(values);

    const handleChange = (name: string, value: any) => {
        setFormValues({
            ...formValues,
            [name]: value
        });
    }

    const handleChangeMultiple = (multipleValues: any) => {
        setFormValues({
            ...formValues,
            ...multipleValues
        });
    }

    return {
        handleInitialize,
        handleChange,
        handleChangeMultiple,
        formValues
    };
}